import { Component, OnInit } from '@angular/core';
import { EbwModalService } from '@ebw-monorepo/modal';
import { transform } from 'ol/proj';
import { FeatureStyle } from '../../../models/style.model';
import { LayerStylesService } from '../../../services/layer-styles.service';
import { MapService } from '../../../services/map.service';

@Component({
  selector: 'ebw-map-go-to-position',
  templateUrl: './go-to-position.component.html',
  styleUrls: ['./go-to-position.component.scss']
})
export class GoToPositionComponent implements OnInit {

  POSITION_MARKER_TITLE = "positionMarker";

  buttonTooltip: string = "";

  //locationMarkerDisappearMilliseconds = 1000 * 15; //30 seconds to remove the marker;
  markerTimeout = null;

  positionWatcherId: number = null;

  locationMarkerStyle: FeatureStyle = {
    image: {
      scale: 0.04,
      src:"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"512pt\" height=\"512pt\" viewBox=\"0 0 512.000000 512.000000\" preserveAspectRatio=\"xMidYMid meet\"><g transform=\"translate(0.000000,512.000000) scale(0.100000,-0.100000)\" fill=\"#000000\" stroke=\"none\"><path d=\"M2510 4901 c-74 -24 -119 -63 -145 -123 -12 -30 -15 -84 -15 -280 l0 -243 -112 -22 c-334 -64 -639 -227 -882 -469 -242 -243 -405 -548 -469 -881 l-22 -113 -243 0 c-196 0 -250 -3 -280 -15 -169 -71 -169 -319 0 -390 30 -12 84 -15 280 -15 l243 0 22 -113 c64 -333 227 -638 470 -880 243 -244 547 -406 881 -470 l112 -22 0 -243 c0 -196 3 -250 15 -280 64 -152 273 -172 370 -34 l30 44 3 257 3 257 112 21 c534 103 988 458 1221 955 58 123 102 258 129 395 l21 112 257 3 257 3 44 30 c138 97 118 306 -34 370 -30 12 -84 15 -280 15 l-243 0 -22 113 c-133 682 -669 1218 -1350 1350 l-113 22 0 243 c0 259 -5 288 -53 340 -47 51 -149 82 -207 63z m239 -1077 c552 -81 994 -523 1075 -1075 30 -200 13 -394 -49 -584 -65 -200 -160 -352 -314 -506 -201 -202 -439 -323 -714 -363 -700 -104 -1350 380 -1453 1084 -29 200 -7 421 61 610 132 363 420 649 785 778 194 68 399 87 609 56z\"/><path d=\"M2383 3394 c-166 -36 -303 -112 -428 -238 -163 -164 -245 -364 -245 -596 0 -470 377 -850 845 -850 239 0 438 82 606 249 166 167 249 367 249 600 0 178 -45 327 -141 471 -127 189 -318 319 -539 366 -81 17 -265 16 -347 -2z m248 -414 c226 -43 384 -258 350 -477 -30 -191 -173 -334 -364 -364 -223 -35 -437 126 -478 359 -31 172 73 367 235 443 98 46 166 56 257 39z\"/></g></svg>",
    },
    name:"locationMarker"
  }

  constructor(
    private ebwModalService: EbwModalService,
    private mapService: MapService,
    private stylesService: LayerStylesService
  ) { }

  ngOnInit(): void {
  }

  locateMe(){
    //If in a very specific case the positionWatcherId is still existing, clear the watch.
    if(this.positionWatcherId != null){
      navigator.geolocation.clearWatch(this.positionWatcherId);
      this.positionWatcherId = null;
    }

    //check if browser supports geolocation
    if (navigator.geolocation) {
      this.positionWatcherId = navigator.geolocation.watchPosition(
        (position) => {
          //Handle the position that arrives
          this.handleGeolocation(position);

          //Remove the watcher so it only goes to position once.
          navigator.geolocation.clearWatch(this.positionWatcherId);
          this.positionWatcherId = null;
        }
      );
    } else {
      this.ebwModalService.openErrorModal({
        title: "Geolocation Error",
        content:
          "Geolocalizzazione non riuscita oppure non supportata da questo browser.",
      });
    }
  }

  handleGeolocation(position){
    //Clear the marker timeout if it exists
    if(this.markerTimeout){
      clearTimeout(this.markerTimeout);
      this.markerTimeout = null;
    }
    //Remove existing position marker if it exists
    this.mapService.removeMarker(this.POSITION_MARKER_TITLE);
    //this.rimuoviFeatureFromTag(this.tmpLayer, "accuracy");

    if (position !== null) {
      const coordinate4326 = [position.coords.longitude, position.coords.latitude];
      const coordinate3857 = transform(
        coordinate4326,
        MapService.EPSG_4326_KEY,
        MapService.EPSG_3857_KEY
      );  

      let positionMarkerStyle = this.stylesService.buildStyleFromFeatureStyle(this.locationMarkerStyle);

      //Adds a marker on the map
      this.mapService.addMarker(this.POSITION_MARKER_TITLE, coordinate4326, positionMarkerStyle);

      //Leave the marker for locationMarkerDisappearMilliseconds milliseconds and then remove it
      // this.markerTimeout = setTimeout( ()=>{
      //   this.mapService.removeMarker(this.POSITION_MARKER_TITLE)
      // }, this.locationMarkerDisappearMilliseconds);      

      this.mapService.setMapCenter(coordinate4326);
      //this.mappaOpenLayer.getView().setCenter(coordinate);
    }
  }
}
